import { loadScript } from '@/utils/script';
import { Utils } from '@/types';

const src = 'https://consent.cookiebot.com/uc.js';

export function loadCookiebotScript() {
  const brand = Utils.Cobrand.get();
  if (brand === Utils.Cobrand.Params.Anna) {
    return;
  }

  loadScript(src, null, {
    id: 'Cookiebot',
    ['data-cbid']: 'fdee16ec-b530-4b4b-a0a7-e7fd70368fc2',
  });
}
